"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var react_i18next_1 = require("react-i18next");
var services_1 = require("stremio/services");
var common_1 = require("stremio/common");
var components_1 = require("stremio/components");
var UpdaterBanner_less_1 = __importDefault(require("./UpdaterBanner.less"));
var UpdaterBanner = function (_a) {
    var className = _a.className;
    var t = (0, react_i18next_1.useTranslation)().t;
    var shell = (0, services_1.useServices)().shell;
    var shellTransport = (0, common_1.useShell)();
    var _b = (0, common_1.useBinaryState)(false), visible = _b[0], show = _b[1], hide = _b[2];
    var onInstallClick = function () {
        shellTransport.send('autoupdater-notif-clicked');
    };
    (0, react_1.useEffect)(function () {
        shell.transport && shell.transport.on('autoupdater-show-notif', show);
        return function () {
            shell.transport && shell.transport.off('autoupdater-show-notif', show);
        };
    }, []);
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(components_1.Transition, { when: visible, name: 'slide-up' },
            react_1.default.createElement("div", { className: UpdaterBanner_less_1.default['updater-banner'] },
                react_1.default.createElement("div", { className: UpdaterBanner_less_1.default['label'] }, t('UPDATER_TITLE')),
                react_1.default.createElement(components_1.Button, { className: UpdaterBanner_less_1.default['button'], onClick: onInstallClick }, t('UPDATER_INSTALL_BUTTON')),
                react_1.default.createElement(components_1.Button, { className: UpdaterBanner_less_1.default['close'], onClick: hide },
                    react_1.default.createElement(react_2.default, { className: UpdaterBanner_less_1.default['icon'], name: 'close' }))))));
};
exports.default = UpdaterBanner;
